import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Truck, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileWarehouseTrucksPage() {
  const navigate = useNavigate();
  const [trucks, setTrucks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTrucks = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/warehouse/trucks`);
      setTrucks(res.data || []);
    } catch (err) {
      console.error('Failed to fetch trucks:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTrucks();
  }, [fetchTrucks]);

  if (loading) {
    return (
      <div className="mobile-page">
        <div className="mobile-loading"><div className="mobile-spinner" /></div>
      </div>
    );
  }

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/warehouse')}>
        <ArrowLeft size={18} /> Warehouse
      </button>

      <div className="mobile-page-title" style={{ marginBottom: 16 }}>Trucks</div>

      {trucks.length === 0 ? (
        <div className="mobile-empty-state">
          <Truck />
          <p>No trucks at dock</p>
        </div>
      ) : (
        <div className="mobile-menu-list">
          {trucks.map((truck) => (
            <button
              key={truck.truck_id}
              className="mobile-menu-item"
              onClick={() => navigate(`/warehouse/trucks/${truck.truck_id}`)}
            >
              <div className="mobile-menu-item-icon" style={{ background: truck.status === 'at_dock' ? '#ff9500' : truck.status === 'unloading' ? '#007aff' : '#34c759' }}>
                <Truck size={16} />
              </div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{truck.carrier || truck.truck_id}</div>
                <div className="mobile-menu-item-subtitle">
                  {truck.status || 'Unknown'} · Dock {truck.dock_door || 'N/A'}
                </div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
